import React from 'react';

// Import all icon components
import {
  ExclamationCircleIcon,
  UserIcon,
  LogoutIcon,
  SettingsIcon,
  ChevronDownIcon,
  HomeIcon,
  DocumentIcon,
  FileIcon,
  XIcon,
  EllipsisVerticalIcon,
  ExternalLinkIcon,
  PencilIcon,
  TrashIcon,
  BlogIcon,
  InfoIcon,
  MailIcon,
  ChartBarIcon,
  SunIcon,
  MoonIcon,
  ArrowUpIcon,
  PlayIcon,
  XCircleIcon,
  LogInIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ArrowLeftIcon,
  PlayCircleIcon,
  AArrowDownIcon,
  AArrowUpIcon,
  ChevronUpIcon,
  GlobeIcon,
  MenuIcon,
  ArrowRightIcon,
  ListIcon,
  FileTextIcon,
  HomeSolidIcon,
  PlaySolidIcon,
  GithubIcon,
  LinkedinIcon,
  LockIcon,
  SearchIcon,
  BookOpenIcon,
  SparklesIcon,
  FlameIcon,
  ClockIcon,
  CheckCircleIcon,
  CheckIcon,
} from './Icons';

// Icon name to component mapping
const iconMap = {
  'exclamation-circle': ExclamationCircleIcon,
  'user': UserIcon,
  'logout': LogoutIcon,
  'settings': SettingsIcon,
  'chevron-down': ChevronDownIcon,
  'home': HomeIcon,
  'document': DocumentIcon,
  'file': FileIcon,
  'x': XIcon,
  'ellipsis-vertical': EllipsisVerticalIcon,
  'external-link': ExternalLinkIcon,
  'pencil': PencilIcon,
  'trash': TrashIcon,
  'blog': BlogIcon,
  'info': InfoIcon,
  'mail': MailIcon,
  'chart-bar': ChartBarIcon,
  'sun': SunIcon,
  'moon': MoonIcon,
  'arrow-up': ArrowUpIcon,
  'play': PlayIcon,
  'x-circle': XCircleIcon,
  'log-in': LogInIcon,
  'chevron-left': ChevronLeftIcon,
  'chevron-right': ChevronRightIcon,
  'arrow-left': ArrowLeftIcon,
  'play-circle': PlayCircleIcon,
  'a-arrow-down': AArrowDownIcon,
  'a-arrow-up': AArrowUpIcon,
  'chevron-up': ChevronUpIcon,
  'globe': GlobeIcon,
  'menu': MenuIcon,
  'arrow-right': ArrowRightIcon,
  'list': ListIcon,
  'file-text': FileTextIcon,
  'home-solid': HomeSolidIcon,
  'play-solid': PlaySolidIcon,
  'github': GithubIcon,
  'linkedin': LinkedinIcon,
  'lock': LockIcon,
  'search': SearchIcon,
  'book-open': BookOpenIcon,
  'sparkles': SparklesIcon,
  'flame': FlameIcon,
  'clock': ClockIcon,
  'check-circle': CheckCircleIcon,
  'check': CheckIcon,
} as const;

export type IconName = keyof typeof iconMap;

interface IconProps extends React.SVGProps<SVGSVGElement> {
  name: IconName;
  size?: number | string;
}

export const Icon: React.FC<IconProps> = ({ name, size = 24, className, ...props }) => {
  const SvgComponent = iconMap[name];

  if (!SvgComponent) {
    console.warn(`Icon "${name}" not found`);
    return null;
  }

  return (
    <SvgComponent
      width={size}
      height={size}
      className={className}
      {...props}
    />
  );
};